// export const LEVELS = [
//   "level.amateur",
//   "level.semipro",
//   "level.professional",
//   "level.elite"
// ];


export const LEVELS = [
  {
    value: "Amateur",
    label: "level.amateur"
  },
  {
    value: "Semi-pro",
    label: "level.semipro"
  },
  {
    value: "Professionnel",
    label: "level.professional"
  },
  {
    value: "Élite",
    label: "level.elite"
  }
];